import {
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
  TextField,
} from "@material-ui/core";
import CircleIcon from "@mui/icons-material/Circle";
import HeaderClientes from "components/_refactor/headers/clients";
import TableCnpj from "./components/tableCnpj";
import FilterCard from "components/_refactor/filter-card";
import { useEffect, useState } from "react";
import StructureFields from "components/_refactor/fields/structure";
import verifyProfilesVision from "utils/verifyProfilesVision";
import AddressCard from "./components/address-dialog";
import RepresentativesCard from "./components/representate-dialog";
import SolicitarAlteracaoDialog from "./components/solicitar-alteracao-dialog";
import ContactCard from "./components/contact-dialog";
import UsersCard from "./components/users-dialog";
import Api from "lib/api/httpRequestHelper";
import MaskAndValid from "utils/maskAndValid";

export default function MeuCadastro() {
  const isRepresentant = verifyProfilesVision(["REPRESENTANTE", "ADM"]);

  const [structureFilters, setStructureFilters] = useState();
  const [clearFilters, setClearFilters] = useState(false);
  const [structureLoading, setStructureLoading] = useState([]);
  const [economicGroup, setEconomicGroup] = useState(null);
  const [searching, setSearching] = useState(false);
  const [openedModal, setOpenedModal] = useState(null);
  const [type, setType] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const [cnpj, setCnpj] = useState("");
  const isValidCnpj = cnpj ? MaskAndValid.validateCNPJ(cnpj) : false;
  const unmaskedCnpj = cnpj?.replace(/[^\d]+/g, "");

  const handleSearch = async () => {
    setSearching(true);
    try {
      let query = "";

      if (isValidCnpj) {
        query = `?cnpj=${unmaskedCnpj}`;
      } else if (isRepresentant && structureFilters?.idGrupoEconomico) {
        query = `?idGrupoEconomico=${structureFilters.idGrupoEconomico}`;
      } else {
        setEconomicGroup(null);
        return;
      }

      const response = await Api.get(
        "store-group-search",
        "commercialstructure",
        query,
        true
      );
      setEconomicGroup(response?.Result || null);
    } catch (error) {
      console.error("Erro ao buscar grupo econômico:", error);
      setEconomicGroup(null);
    } finally {
      setSearching(false);
    }
  };

  const handleClearFilters = () => {
    setEconomicGroup(null);
    setCnpj("");
    setClearFilters(true);

    setTimeout(() => {
      setClearFilters(false);
    }, 300);
  };

  const activeColor =
    economicGroup?.StatusGrupoEconomico === "ATIVO" ? "success" : "error";

  useEffect(() => {
    handleSearch();
  }, []);

  return (
    <div>
      <HeaderClientes section="Meu Cadastro" subsection="Clientes" />
      <Container maxWidth={false} style={{ marginTop: "-4.5rem" }}>
        {isRepresentant && (
          <FilterCard
            handleSearch={handleSearch}
            disabled={!isValidCnpj && !structureFilters?.idGrupoEconomico}
            searching={searching}
            handleClearFilters={handleClearFilters}
          >
            <Grid container spacing={2} alignItems="flex-end">
              <Grid item xs={12} sm={12}>
                <StructureFields
                  clearFilters={clearFilters}
                  onStructureFieldsChange={setStructureFilters}
                  disableAll={!!structureLoading.length}
                  onStructureFieldsLoad={setStructureLoading}
                  requiredFields={isValidCnpj ? [] : ["economicGroup"]}
                  hideFields={["brand", "channel", "representative", "store"]}
                  handleSearch={handleSearch}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
              <TextField
                  fullWidth
                  label="CNPJ"
                  value={cnpj}
                  onChange={(e) =>
                    setCnpj(MaskAndValid.maskCNPJ(e.target.value.slice(0, 18)))
                  }
                  placeholder="___.___.___/____-__"
                  variant="outlined"
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && isValidCnpj) {
                      handleSearch();
                    }
                  }}
                  error={!!cnpj && !isValidCnpj}
                  helperText={!!cnpj && !isValidCnpj ? "CNPJ inválido" : " "}
                />
              </Grid>
            </Grid>
          </FilterCard>
        )}
        {economicGroup && (
          <>
            <Card>
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={3}>
                    <Typography variant="subtitle2">Código do Grupo</Typography>
                    <Typography variant="caption">
                      {economicGroup.IdGrupoEconomico}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle2">
                      Grupo Econômico/Razão Social
                    </Typography>
                    <Typography variant="caption">
                      {economicGroup.NomeGrupoEconomico}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={2}>
                    <Typography variant="subtitle2">Código ERP</Typography>
                    <Typography variant="caption">
                      {economicGroup.CodigoErpGrupoEconomico}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={1} style={{ alignItems: "center" }}>
                    <Typography variant="subtitle2">Ativo</Typography>
                    <CircleIcon color={activeColor} />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <TableCnpj
              data={economicGroup.Lojas}
              onClick={setOpenedModal}
              selectedRow={setSelectedRow}
            />
          </>
        )}
      </Container>

      {openedModal === "ADDRESS" && (
        <AddressCard
          storeId={selectedRow?.IdPessoaLoja}
          setOpenedModal={setOpenedModal}
          setType={setType}
        />
      )}

      {openedModal === "REPRESENTANTE" && (
        <RepresentativesCard
          storeId={selectedRow?.IdPessoaLoja}
          setOpenedModal={setOpenedModal}
          setType={setType}
        />
      )}

      {openedModal === "CONTACT" && (
        <ContactCard
          storeId={selectedRow?.IdPessoaLoja}
          setOpenedModal={setOpenedModal}
          setType={setType}
        />
      )}

      {openedModal === "USERS" && (
        <UsersCard
          storeId={selectedRow?.IdPessoaLoja}
          setOpenedModal={setOpenedModal}
          setType={setType}
        />
      )}

      {openedModal === "ALTERACAO" && (
        <SolicitarAlteracaoDialog
          storeId={selectedRow?.IdPessoaLoja}
          type={type}
          onClose={() => setOpenedModal(null)}
        />
      )}
    </div>
  );
}